import catalogContexts from "@utils/constants/catalogContexts";
import algoliaIndices from "@utils/constants/algoliaIndices";

const { mainIndexV1, mainIndexV2, baseSalesIndex } = algoliaIndices;

export default function findOrderByOptions(catalogVersion) {
  if (catalogVersion === 1) {
    return [
      { label: "our_choice", value: mainIndexV1, context: catalogContexts.swap },
      { label: "discovery", value: `${mainIndexV1}-discovery`, context: catalogContexts.swap },
      { label: "newest", value: `${mainIndexV1}-newest`, context: catalogContexts.swap },
      { label: "our_choice", value: baseSalesIndex, context: catalogContexts.sales },
      { label: "price", value: `${baseSalesIndex}-price`, context: catalogContexts.sales },
      { label: "discount", value: `${baseSalesIndex}-discount`, context: catalogContexts.sales },
    ];
  }

  return [
    { label: "our_choice", value: mainIndexV2, context: catalogContexts.swap },
    {
      label: "newest",
      value: mainIndexV2.replace("principal", "newest"),
      context: catalogContexts.swap,
    },
    {
      label: "our_choice",
      value: mainIndexV2.replace("principal", "sale"),
      context: catalogContexts.sales,
    },
    {
      label: "price",
      value: mainIndexV2.replace("principal", "price"),
      context: catalogContexts.sales,
    },
    {
      label: "discount",
      value: mainIndexV2.replace("principal", "discount"),
      context: catalogContexts.sales,
    },
  ];
}
